import isEqual from 'lodash-es/isEqual';

export function isEqualDeep(x, y) {
  return isEqual(x, y);
}

export function arrayReplaceAt(array, index, value) {
  const ret = array.slice(0);
  ret[index] = value;
  return ret;
}

export function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function isEmptyArray(arr) {
  return !Array.isArray(arr) || !arr.length;
}

export function removeNullValuesFromObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v));
}

export function removeEmpty(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null && v !== undefined)
  );
}

export function* enumerate(iterable) {
  let i = 0;

  for (const x of iterable) {
    yield [i, x];
    i++;
  }
}

export function objectHasOwn(obj, name) {
  if (typeof obj !== 'object') {
    return false;
  }

  if ('hasOwn' in Object) {
    return Object.hasOwn(obj, name);
  }

  return Object.prototype.hasOwnProperty.call(obj, name);
}

export function clamp(num, min, max) {
  return num <= min ? min : num >= max ? max : num;
}
